import gql from 'graphql-tag';

import integrationItemFragment from './integrationItemFragment';

export const integrationThreadBodyFragment = gql`
  fragment integrationThreadBodyFragment on IntegrationThreadBody {
    dokkioClass
    emailMessagesHTML
    attachments {
      ...integrationItemFragment
    }
  }
  ${integrationItemFragment}
`;
export default integrationThreadBodyFragment;
